import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CaseService } from '../../services/case.service';
import { DictionaryService } from '../../services/dictionary.service';
import { UtilitiesService } from '../../services/utilities.service';
import { ApplicationAssessorDto } from './dto/application-assessor.dto';
import { MessageService, Message, ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-case-assessor',
  templateUrl: './case-assessor.component.html'
})

export class CaseAssessorComponent implements OnInit {

  @Input() caseId: string;
  @Input() assessorType: string;
  @Output() changeEvent = new EventEmitter();

  valuesCount = 0;
  myAssessor: ApplicationAssessorDto;
  myValueAssessor: any; // ApplicationValueDto;
  myTotalValue: any; // contains calculated totals
  myProperty: any;  // contains UseCode from Property data
  myEmitObject: any; // composite object containing ALL values, totals, roll type, etc
  readyToExit = false; // flag used to signal parent component that we saved Assessor data and are ready to exit Case module...

  //
  assessorCrewChoiceList = [];  // ChoiceLists.assessorCrewChoices;
  assessorDivisionChoiceList = []; // ChoiceLists.assessorDivisionChoices;
  assessorSpecialCaseChoiceList = [];
  useCodeChoiceList = [];
  appraiserChoiceList = [];

  //
  saveStatus = 0; // 0 = failed to save, 1 = OK, 2 = partial save
  displayState: any = {
      workingDiv: false,
      assessorMessage: '',
  };

  constructor(private caseService: CaseService, private dictService: DictionaryService, private utilService: UtilitiesService
            , private messageService: MessageService, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    if (!this.caseId) { // it's a new case...
      return;
    }
    // initialize myProperty object to avoid emitObject-related error
    this.myProperty = {
      useCode: ''
    };

    this.saveStatus = 0;
    this.valuesCount = 0; // we keep bumping this counter up as we load pieces of data; use it to make sure we don't load the "form" until we have ALL the required data!
    this.loadDictionaries();
    this.caseService.getCaseAssessor(this.caseId).subscribe(data1 => {
      this.valuesCount = ++this.valuesCount;
      this.myAssessor = data1; // needed here to display values for Assessor Name, Division, Complex Case, etc
      this.utilService.doAudit(data1, 'get assessor response:');
    });
    this.caseService.getValueGroup(this.caseId, 'assessor').subscribe(data2 => {
        this.myValueAssessor = data2;
        this.formatTemplateValues([3, 13, 23, 33, 43, 53, 63, 73, 83]);
        this.calcTotalAssessorValue();
        this.valuesCount = ++this.valuesCount;
      });
    this.caseService.getCaseProperty(this.caseId).subscribe(data3 => {
      this.utilService.doAudit(data3, 'PROPERTY DATA in Assessor tab:');
      this.valuesCount = ++this.valuesCount;
      if (data3) {
        this.myProperty = data3;
      }
    });
    this.assessorType = this.assessorType ? this.assessorType : 'Assessor-Manager';
  }

  changeAssessor() {
    // this.utilService.doAudit(this.myAssessor, 'changed assessor; myAssessor:');
    const appraiserId = this.myAssessor.appraiserId;
    if (appraiserId) {
    // get the Appraiser name and set it in myAssessor.appraiserName
      const tAppraiser = this.appraiserChoiceList.find(x => x.id.toString() === appraiserId.toString());
      // this.utilService.doAudit(tAppraiser, 'tAppraiser found:');
      if (tAppraiser) {
        this.myAssessor.appraiserName = tAppraiser.name;
      }
    }
  }

  // **** NOTE: we will be saving Assessor data here (and NOT in the parent component); after done, should we exit case??
  saveAssessor() {
    // ask for confirmation??
    this.displayState.assessorMessage = ''; // used to let user know if saving was successful (or not); replacing w/ either Toaster or Confirmation message...
    // save Assessor stuff here
    const appId = this.caseId;
    this.myAssessor.applicationId = Number(appId);
    // set appraiserId to 0 if it's null (so case lookup for "Not Assigned" works! - rod 1/14/2025
    this.myAssessor.appraiserId = this.myAssessor.appraiserId ?? 0;
    this.utilService.doAudit(this.myAssessor, 'about to save myAssessor:');
    this.caseService.saveAssessor(this.myAssessor).subscribe(data => {
      this.utilService.doAudit(data, 'returned from saveAssessor:');
      if (data) { this.saveStatus = 1; }
      // now save the Assessor Values
      this.utilService.doAudit(this.myValueAssessor, 'about to save myValueAssessor:');
      this.caseService.saveCaseValueGroup(appId, 'assessor', this.myValueAssessor).subscribe(data2 => {
        this.utilService.doAudit(data2, 'returned from saveCaseValueGroup - Assessor:');
        // finally, save Usecode, if any...
        if (this.myProperty.useCode) {
          this.utilService.doAudit(this.myProperty.useCode, 'about to save useCode:');
          this.caseService.saveAssessorUsecode(appId, this.myProperty.useCode).subscribe(data3 => {
            this.utilService.doAudit(data3, 'returned from saveAssessorUsecode:');
            this.exitModule();
          });
        } else {
          this.exitModule();
        }
      });
    });
  }

  // NOTE:  save ONLY comments?? (implies user did not have access to enter/edit other fields; confirm w/ Alan)
  saveComment() {
    const appId = this.caseId;
    this.myAssessor.applicationId = Number(appId);
    this.utilService.doAudit(this.myAssessor, 'about to save Assessor comments stored in this object:');
    this.caseService.saveAssessor(this.myAssessor).subscribe(data => {
      this.utilService.doAudit(data, 'returned from saveAssessor:');
      if (data) { this.saveStatus = 1; }
      this.exitModule();
    });
  }

  // emit object and let parent know we're ready to exit Module...
  exitModule() {
    this.utilService.doAudit(this.saveStatus, 'save Status:');
    if (this.saveStatus === 1 ) {
      this.showToast({ key: 'infoAssessor', severity: 'success', detail: 'Assessor Info Filed', summary: 'Info' });
      // navigate to Case Lookup page
      // this.exitCase();
    } else {
      this.showToast({ key: 'infoAssessor', severity: 'error', detail: 'Problem saving Assessor data!', summary: 'Error' });
    }
    this.readyToExit = true;
    /*
    this.updateEmitObject();   // create composite object
    this.utilService.doAudit(this.myEmitObject, 'emitting composite object and exiting module:');
    this.changeEvent.emit(this.myEmitObject); // transmit ALL values
    */
  }

  // load all dictionaries used by Select elements
  loadDictionaries() {
    this.dictService.getCaseDictionaries('crew').subscribe(data => {
      this.utilService.doAudit(data, 'crew dictionary:');
      if (data) {
        this.assessorCrewChoiceList = data;
      }
      this.valuesCount = ++this.valuesCount;

    });
    this.dictService.getCaseDictionaries('division').subscribe(data => {
      this.utilService.doAudit(data, 'division dictionary:');
      if (data) {
        this.assessorDivisionChoiceList = data;
      }
      this.valuesCount = ++this.valuesCount;

    });
    this.dictService.getCaseDictionaries('specialcase').subscribe(data => {
      if (data) {
        this.assessorSpecialCaseChoiceList = data;
      }
      this.valuesCount = ++this.valuesCount;
    });
    this.dictService.getCaseDictionaries('usecode').subscribe(data => {
      this.utilService.doAudit(data, 'usecode dictionary:');
      if (data) {
        this.useCodeChoiceList = data;
      }
      this.valuesCount = ++this.valuesCount;
    });
    this.dictService.getAssessorList().subscribe(data => {
      if (data) {
        this.utilService.doAudit(data, 'Appraiser dictionary:');
        this.appraiserChoiceList = data;
        this.appraiserChoiceList.unshift({ id: 0, name: '', isActive: false }); // add blank at beginning (to allow "clearing" of previous selection)
        // FILTER ON isActive flag??
      }
      this.valuesCount = ++this.valuesCount;
    });
  }

    showForAccessLevel(privLevel: number): boolean {
        // levels:  0 (view-only), 1 = view-only & assessor, 2 = supervisor, 3 = supervisor & manager, 4 = manager
      let isAllowed = false;
      const isDeveloper = this.utilService.isDeveloper();
      if (privLevel == 0) {
        if (this.assessorType == 'Assessor-ReadOnly') {
          isAllowed = true;
        }
      }
      else if (privLevel == 1) {
        if (this.assessorType == 'Assessor-ReadOnly' || this.assessorType == 'Assessor') {
          isAllowed = true;
        }
      }
      else if (privLevel == 2) {
        if (this.assessorType == 'Assessor') {
          isAllowed = true;
        }
      }
      else if (privLevel == 3) {
        if (this.assessorType == 'Assessor-Supervisor' || this.assessorType == 'Assessor-Manager') {
          isAllowed = true;
        } else if (isDeveloper) { isAllowed = true; }
      }
      else if (privLevel == 4) {
        if (this.assessorType == 'Assessor-Manager') {
          isAllowed = true;
        } else if (isDeveloper) { isAllowed = true; }
      }
      return isAllowed;
    }

      // update composite Values object, for trasmission to Parent component (via event emitter)
    updateEmitObject() {
        this.myEmitObject = {
          assessor: this.myAssessor,
          valueAssessor: this.myValueAssessor,
          useCode: this.myProperty.useCode,
          readyToExit: this.readyToExit,
        };
    }

    calcTotalAssessorValue() {
      let myTotal: number;
      // tslint:disable-next-line:max-line-length
      myTotal = this.utilService.stripCommas(this.myValueAssessor.landValue) +
        this.utilService.stripCommas(this.myValueAssessor.improveValue) +
        this.utilService.stripCommas(this.myValueAssessor.fixturesValue) +
        this.utilService.stripCommas(this.myValueAssessor.mineralValue) +
        this.utilService.stripCommas(this.myValueAssessor.treesValue) +
        this.utilService.stripCommas(this.myValueAssessor.personalValue);
      this.myTotalValue = this.utilService.thouSeparator(myTotal);
    }

  // this method is executed whenever any data in the component is changed; it should trigger an event defined on the PARENT component
  dataChange() {
    this.utilService.doAudit(this.myAssessor, 'assessor data changed');
    this.calcTotalAssessorValue();
    this.updateEmitObject();   // create composite object
    this.changeEvent.emit(this.myEmitObject); // transmit ALL values
    this.utilService.doAudit(this.myEmitObject, 'emitted composite object:');
  }
// format the values - this is run from ngOnInit (i.e. when we get the initial data)
    formatTemplateValues(mySource: number[]) {
      this.utilService.doAudit(mySource, 'about to format these values:');
      for (let i = 0; i < mySource.length; i++) {
        this.addCommas(mySource[i], false);
      }
    }

  addCommas(myNum: number, fromTemplate: boolean = true) {
    // user has left the input element...
    // calculate the totals, but only if the change initiated w/ the user coz we would have gotten the initial value along w/ the other values
    if (fromTemplate) { this.calcTotalAssessorValue(); }
    //
    // add the commas to the field we just left...
    let myVal: any;
    const myCateg = Math.trunc(myNum / 10); // using the same numbers as in the Values component to reuse the code...
    if (myCateg == 0) { // Land Values
        myVal = this.myValueAssessor.landValue;
        this.myValueAssessor.landValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 1) {  // improvements
        myVal = this.myValueAssessor.improveValue;
        this.myValueAssessor.improveValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 2) {  // fixtures
        myVal = this.myValueAssessor.fixturesValue;
        this.myValueAssessor.fixturesValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 3) {  // personal property
        myVal = this.myValueAssessor.personalValue;
        this.myValueAssessor.personalValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 4) {  // mineral rights
        myVal = this.myValueAssessor.mineralValue;
        this.myValueAssessor.mineralValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 5) {  // trees and vines
        myVal = this.myValueAssessor.treesValue;
        this.myValueAssessor.treesValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 6) {  // exemptions
        myVal = this.myValueAssessor.exemptValue;
        this.myValueAssessor.exemptValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 7) {  // penalties
        myVal = this.myValueAssessor.penaltyValue;
        this.myValueAssessor.penaltyValue = this.utilService.thouSeparator(myVal);
    } else if (myCateg == 8) {  // net totals
        myVal = this.myValueAssessor.netValue;
        this.myValueAssessor.netValue = this.utilService.thouSeparator(myVal);
    }

    // if the change was initiated by user interaction in template, emit the change to the parent
    // CORRECTION: since we're saving the data from this tab, we don't need to emit to the parent (unless we want to keep it in sync??)
    // if (fromTemplate) { this.valueChanged(myNum); }
  }

  removeCommas(myNum: number) {
    // when user is doing input, we remove commas
    this.utilService.doAudit(myNum, 'removing commas for:');
    const myCateg = Math.trunc(myNum / 10);
    const mySource = +myNum % 10;
    if (myCateg === 0) {  // land values
        this.myValueAssessor.landValue = this.utilService.stripCommas(this.myValueAssessor.landValue, false);
    } else if (myCateg == 1) {  // improvements
        this.myValueAssessor.improveValue = this.utilService.stripCommas(this.myValueAssessor.improveValue, false);
    } else if (myCateg == 2) {  // fixtures
        this.myValueAssessor.fixturesValue = this.utilService.stripCommas(this.myValueAssessor.fixturesValue, false);
    } else if (myCateg == 3) {  // personal property
        this.myValueAssessor.personalValue = this.utilService.stripCommas(this.myValueAssessor.personalValue, false);
    } else if (myCateg == 4) {  // mineral rights
        this.myValueAssessor.mineralValue = this.utilService.stripCommas(this.myValueAssessor.mineralValue, false);
    } else if (myCateg == 5) {  // trees and vines
        this.myValueAssessor.treesValue = this.utilService.stripCommas(this.myValueAssessor.treesValue, false);
    } else if (myCateg == 6) {  // exemptions
        this.myValueAssessor.exemptValue = this.utilService.stripCommas(this.myValueAssessor.exemptValue, false);
    } else if (myCateg == 7) {  // penalties
        this.myValueAssessor.penaltyValue = this.utilService.stripCommas(this.myValueAssessor.penaltyValue, false);
    } else if (myCateg == 8) {  // net totals
        this.myValueAssessor.netValue = this.utilService.stripCommas(this.myValueAssessor.netValue, false);
    }
  }

    // Toaster/Message-related methods
    showToast(msg: Message) {
      this.messageService.clear('toastAssessor');
      this.messageService.add(msg);
    }

    showInfo(myMsg: Message) {
      this.messageService.clear('infoAssessor');
      this.messageService.add(myMsg);
    }

    clearAll() {
      this.messageService.clear();
    }

}
